"use strict";

exports.__esModule = true;
exports.default = void 0;
var _consts = require("../consts");
const resolveColor = () => ({
  theme,
  selected,
  type
}) => {
  if (selected) return theme.orbit.paletteWhite;
  return type === _consts.TYPES.NEUTRAL ? theme.orbit.paletteInkDark : theme.orbit.paletteBlueDarker;
};
var _default = resolveColor;
exports.default = _default;